import React, { useState } from 'react'
import GoldDiggersClub from './competition/GoldDiggersClub'
import ContactForm from './ContactForm'
import { HowToStartVideos } from './HowToStartVideos'
import { LiveActivityFeed } from './calculator/LiveActivityFeed'
import { TermsAndConditions } from './TermsAndConditions'
import { PrivacyPolicy } from './PrivacyPolicy'
import { ComprehensiveDisclaimer } from './ComprehensiveDisclaimer'


interface AffiliateLandingPageProps {
  onBackHome?: () => void
  onGoToAuth?: (mode: 'login' | 'register') => void
  onLogoutAndRegister?: () => void
}

export const AffiliateLandingPage: React.FC<AffiliateLandingPageProps> = ({ onBackHome, onGoToAuth }) => {
  console.log('🏢 AffiliateLandingPage component rendering...');
  const [activeModal, setActiveModal] = useState<string | null>(null);

  const openModal = (modalType: string) => {
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  return (
    <div className="page modern-website">
      {/* Consistent Header */}
      <header className="header premium-header">
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <a href="https://aureus.africa" style={{ display: 'inline-block' }}>
                <img
                  src="https://fgubaqoftdeefcakejwu.supabase.co/storage/v1/object/public/assets/logo-s.png"
                  alt="Aureus Alliance Holdings"
                  className="logo-image"
                />
              </a>
            </div>
            <nav className="nav-menu">
              <div className="nav-main">
                <button
                  className="nav-item premium-nav-item"
                  onClick={() => onBackHome?.()}
                >
                  ← Back to Website
                </button>
                <button
                  className="nav-item premium-nav-item active"
                >
                  Affiliate Program
                </button>
              </div>
              <div className="nav-actions">
                <button
                  className="btn btn-secondary premium-btn-secondary"
                  onClick={() => onGoToAuth?.('login')}
                >
                  Affiliate Login
                </button>
                <button
                  className="btn btn-primary premium-btn"
                  onClick={() => onGoToAuth?.('login')}
                >
                  Join Now
                </button>
              </div>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <section className="hero">
          <div className="container">
            <div className="hero-content">
              <div className="content">
                <div className="badge">
                  <span className="badge-dot"></span>
                  Exclusive Affiliate Opportunity
                </div>
                <h1>Aureus Affiliate Program</h1>
                <p className="hero-description">
                  Join the ultimate affiliate program for Africa's premier gold mining company.
                  Earn substantial commissions while helping others secure their financial future through real gold-backed shares.
                </p>
                <div className="hero-stats">
                  <div className="stat">
                    <div className="stat-value">10%</div>
                    <div className="stat-label">USDT Commission</div>
                  </div>
                  <div className="stat">
                    <div className="stat-value">5%</div>
                    <div className="stat-label">Auto Share Purchase</div>
                  </div>
                  <div className="stat">
                    <div className="stat-value">$150K+</div>
                    <div className="stat-label">Prize Pool</div>
                  </div>
                </div>
                <div className="hero-actions">
                  <button
                    className="btn btn-primary btn-large"
                    onClick={() => onGoToAuth?.('login')}
                  >
                    Become a Gold Diggers Club Member For Free
                  </button>
                  <button
                    className="btn btn-secondary btn-large"
                    onClick={() => onGoToAuth?.('login')}
                  >
                    Affiliate Login
                  </button>
                </div>
              </div>
              <div className="logo">
                <img
                  src="https://fgubaqoftdeefcakejwu.supabase.co/storage/v1/object/public/assets/logo-m.png"
                  alt="Aureus Alliance Holdings"
                  className="hero-logo"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits benefits-compact">
          <div className="container">
            <div className="section-header">
              <h2>Why join</h2>
            </div>
            <div className="benefits-grid">
              <div className="benefit-card">
                <h3>Commission</h3>
                <p>10% USDT + 5% shares on direct sales</p>
              </div>
              <div className="benefit-card">
                <h3>Competitions</h3>
                <p>$150,000+ pools and a public leaderboard</p>
              </div>
              <div className="benefit-card">
                <h3>Tools</h3>
                <p>Dashboard, referral links, and reports</p>
              </div>
            </div>
          </div>
        </section>

        {/* Gold Diggers Club Section */}
        <section className="gold-diggers-section">
          <div className="container">
            <GoldDiggersClub onGoToAuth={onGoToAuth} />
          </div>
        </section>

        {/* How To Start Training Videos */}
        <div className="container">
          <HowToStartVideos
            pageType="affiliate-landing"
            title="Getting Started as an Affiliate"
          />
        </div>
      </main>

      {/* Consistent Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-info">
              <img
                src="https://fgubaqoftdeefcakejwu.supabase.co/storage/v1/object/public/assets/logo-m.png"
                alt="Aureus Alliance Holdings"
                className="footer-logo"
              />
              <h3>Aureus Alliance Holdings (Pty) Ltd</h3>
              <p>CIPC-registered gold mining company • Real shares backed by real gold production</p>
            </div>

            <div className="footer-contact">
              <h4>Contact Us</h4>
              <ContactForm
                className="footer-contact-form"
                onSuccess={() => {
                  console.log('✅ Contact form submitted successfully from affiliate landing page');
                }}
                onError={(error) => {
                  console.error('❌ Contact form error from affiliate landing page:', error);
                }}
              />
            </div>

            <div className="footer-links">
              <p className="footer-links-label">Legal</p>
              <button onClick={() => openModal('privacy')} className="footer-link-btn">
                Privacy Policy
              </button>
              <button onClick={() => openModal('terms')} className="footer-link-btn">
                Terms & Conditions
              </button>
              <button onClick={() => openModal('legal')} className="footer-link-btn">
                Legal Disclaimer
              </button>
              <button
                onClick={() => onBackHome?.()}
                className="footer-link-btn text-gold"
              >
                Back to Website
              </button>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 Aureus Alliance Holdings (Pty) Ltd. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{ maxHeight: '90vh', overflowY: 'auto', padding: '24px' }}
          >
            <button className="modal-close" onClick={closeModal}>×</button>
            {activeModal === 'privacy' && <PrivacyPolicy />}
            {activeModal === 'terms' && <TermsAndConditions />}
            {activeModal === 'legal' && <ComprehensiveDisclaimer />}
          </div>
        </div>
      )}

      {/* Live Shareholder Activity Feed - Hidden on mobile devices */}
      <div className="hidden lg:block">
        <LiveActivityFeed />
      </div>
    </div>
  )
}

export default AffiliateLandingPage

